import { createFileRoute } from '@tanstack/react-router'
import Authentication from '@/components/Authentication'
import { useRedirectToLastUrl } from '@/hooks/useRedirectToLastUrl'

function Login() {
  useRedirectToLastUrl()
  return <Authentication />
}

export const Route = createFileRoute('/login')({
  component: Login,
})
